import { createTossCheckout } from '@platform/billing';
import { getTossPayments } from '@/shared/libs/toss';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';

const toss = createTossCheckout(getTossPayments);

interface EducationPaymentParams {
  customerKey: string;
  /** 서버가 만든 결제레코드의 orderId. 화면이 만들지 않는다. */
  orderId: string;
  orderName: string;
  amount: number;
  registrationId: string;
  customerEmail?: string;
  customerName?: string;
  customerMobilePhone?: string;
}

/**
 * 교육 결제창 오픈.
 *
 * successUrl 에 `edu=<registrationId>` 를 실어 보낸다 — 결제 성공 페이지는 이 값으로
 * "구독 승인" 과 "교육 접수 확정" 을 가른다. 교육은 승인 직전 자리 확보와 승인 후 접수 확정이
 * 더 필요해 일반 confirm 으로 보내면 서버가 거절한다.
 */
export function requestEducationPayment(
  params: EducationPaymentParams,
): Promise<void> {
  const { registrationId, ...rest } = params;
  return toss.requestCardPayment({
    ...rest,
    successUrl: `${window.location.origin}${PATHS.PAYMENT_SUCCESS}?edu=${registrationId}`,
    failUrl: `${window.location.origin}${PATHS.PAYMENT_FAIL}`,
  });
}
